import { z } from 'zod';

/**
 * Enum per lo status dei JobOrderRequirement (esteso)
 * Corrisponde al JobOrderRequirementStatus del backend per autocomplete
 */
export enum JobOrderRequirementStatusExtended {
	Open = 0,
	Closed = 10,
	Canceled = 99,
}

/**
 * RequirementAutocomplete - Requisito per autocomplete
 * Corrisponde al modello backend RequirementAutocomplete
 */
export interface RequirementAutocomplete {
	/** Codice del requisito (normalizzato: senza #, spazi, maiuscolo) */
	code: string;
	/** Descrizione del requisito */
	description: string;
	/** Status interno del requisito */
	internalStatus: JobOrderRequirementStatusExtended;
	/** Descrizione visuale calcolata (code + status + description) */
	visualDescription: string;
}

/**
 * Schema Zod per la validazione di RequirementAutocomplete
 */
export const RequirementAutocompleteSchema = z.object({
	code: z.string(),
	description: z.string(),
	internalStatus: z.nativeEnum(JobOrderRequirementStatusExtended),
	visualDescription: z.string(),
});
